interface String {
  isNullOrWhitespace(): Boolean;
}

String.prototype.isNullOrWhitespace = function (): boolean {
  return !this || !this.trim();
}
